module.exports = __webpack_public_path__ + "img/protocol-black.8377009d.svg";